import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { useToast } from "@/hooks/use-toast";
import { useEffect, useRef } from "react";

/**
 * Protege el módulo de Financiación. El acceso se concede por usuario
 * desde el Panel de administración (los administradores siempre entran).
 * Las empresas visibles siguen limitadas por user_company_access (RLS).
 */
const RequireFinancing = ({
  children,
  redirectTo = "/app/pdf",
}: {
  children: React.ReactNode;
  redirectTo?: string;
}) => {
  const { loading, canAccessFinancing } = useAuth();
  const { toast } = useToast();
  const warned = useRef(false);

  useEffect(() => {
    if (!loading && !canAccessFinancing && !warned.current) {
      warned.current = true;
      toast({
        title: "Sección no disponible",
        description: "Pide al administrador que te habilite el módulo de Financiación.",
        variant: "destructive",
      });
    }
  }, [loading, canAccessFinancing, toast]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <p className="text-muted-foreground">Cargando…</p>
      </div>
    );
  }

  if (!canAccessFinancing) return <Navigate to={redirectTo} replace />;
  return <>{children}</>;
};

export default RequireFinancing;
